import { IClient } from "models/PaymentModel";
export enum TaxSystem {
  NotSelected = 0,
  Emirates = 1,
  Saudi = 2,
  // Kuwait = 3,
  // Qatar = 4,
  // Bahrain = 5,
  // Oman = 6,
  Turkey = 7,
  Egypt = 8,
  Jordan = 9,
  Syria = 10,
}
export enum TaxType {
  None,
  VAT,
  ExciseTax,
}
export enum TaxCoding {
  None,
  SR,
  RC,
  ZR,
  EX,
  IG,
  OA,
  T,
  ET,
  A,
  B,
  C,
  PU,
  XP,
  NA,
  GV,
  TR,
  EP,
  ES,
  O,
}
export enum UAETaxLocation {
  None = 0,
  AbuDhabi = 1,
  Dubai = 2,
  Sharjah = 3,
  Ajman = 4,
  UmmAlQuwain = 5,
  RasAlKhaimah = 6,
  Fujairah = 7,
}
export enum UAETaxType {
  None = 0,
  ValueAddedTax = 1,
}
export interface IUAETaxPeriod {
  id: string;
  code: string;
  latinName: string;
  arabicName: string;
  startDate: Date | string | null;
  endDate: Date | string | null;
}
export interface ITaxSystem {
  system: TaxSystem;
  subscriptionDate: Date | null;
  subscriptionTime?: Date | null;
  defaultClient: any | null;
  defaultClientId: string;
  isPriceIncludeTax: boolean;
  taxNumber: string | null;
  taxNumberCode?: string | null;
  taxLocation?: UAETaxLocation | null;
  taxType?: UAETaxType | null;
  billExporterApp: string | null;
  enableRestaurantTaxes: boolean;
  restaurantTaxes: ISYRRestaurantTax[];
  localAdministrationFee: ILocalAdministrationFee | null;
  enableLocalAdministrationFee: boolean;
  provider: string | null | undefined;
  active: boolean;
  businessActivityId: string | null | undefined;
  businessActivity: IBusinessActivityAutoComplete | null;
  consumptionFeeRoundUpTo?: number | null;
  enableTaxPeriods: boolean;
}

export const EmptyTaxSystem: ITaxSystem = {
  system: TaxSystem.NotSelected,
  subscriptionDate: null,
  subscriptionTime: null,
  defaultClient: null,
  defaultClientId: "",
  isPriceIncludeTax: false,
  taxNumber: null,
  taxNumberCode: null,
  taxLocation: null,
  taxType: null,
  billExporterApp: null,
  enableRestaurantTaxes: false,
  restaurantTaxes: [],
  localAdministrationFee: null,
  enableLocalAdministrationFee: false,
  provider: null,
  active: true,
  businessActivityId: null,
  businessActivity: null,
  consumptionFeeRoundUpTo: null,
  enableTaxPeriods: false,
};

export interface IBusinessActivityAutoComplete {
  id: string | null | undefined;
  name: string | null | undefined;
  latinName: string | null | undefined;
  code: string | null | undefined;
}

export interface IActivateTaxSystem {
  system: TaxSystem;
  subscriptionDate: string | null;
  defaultClientId: string;
  isPriceIncludeTax: boolean;
}

export interface IActivatedTaxSystem {
  system: TaxSystem;
  subscriptionDate?: Date;
  subscriptionTime?: Date;
  defaultClient?: IClient;
  isPriceIncludeTax: boolean;
  taxNumber: string;
  taxNumberCode?: string | null;
  taxLocation?: UAETaxLocation | null;
  taxType?: UAETaxType | null;
  enableUAETaxPeriods?: boolean;
  billExporterApp: string;
  enableRestaurantTaxes: boolean;
  restaurantTaxes: ISYRRestaurantTax[];
  enableLocalAdministrationFee: boolean;
  localAdministrationFee: ILocalAdministrationFee;
  isShiftOpen: boolean;
  organizationCreatedDate?: Date;
  lastShiftCloseDate?: Date;
  provider?: string;
  active: boolean;
  businessActivity?: IBusinessActivityAutoComplete;
  consumptionFeeRoundUpTo?: number | null;
}

export interface IGCCClientTax {
  id: string;
  locationId: string;
  taxType: TaxType;
  taxCoding: TaxCoding;
  country: string;
  taxNumber: string;
}

export interface ISYRRestaurantTax {
  id: string;
  taxName: string;
  taxPercentage: number | null;
  roundUpTo: number;
  active: boolean;
  isUsed: boolean;
}

export interface ILocalAdministrationFee {
  id: string;
  feePercentage: number | null;
  roundUpTo: number;
}

export interface EGPTaxType {
  id: string;
  name: string;
  latinName: string;
  code: string;
  type: number;
  isRatio: boolean;
}

export interface EGPSubTaxType {
  id: string;
  name: string;
  latinName: string;
  code: string;
  type: number;
  isRatio: boolean;
  isExempt: boolean;
  egpTaxTypeId: string;
  egpTaxTypeDto: EGPTaxType;
}

export interface TicketItemEGPTax {
  id: string;
  ratio: number;
  taxValue: number;
  egpTaxTypeId: string;
  egpTaxTypeDto: EGPTaxType;
  defaultSubEGPTaxTypeId: string;
  defaultSubEGPTaxTypeDto: EGPSubTaxType;
}

export interface IPossDevices {
  posId: string;
  provider: string;
  pos: string;
  store: string;
  device: string | null | undefined;
  deviceType: string | null | undefined;
  serialNumber: string | null | undefined;
  username: string | null | undefined;
  password: string | null | undefined;
}

export interface ILinkPosDevice {
  posId: string;
  device: string;
  deviceType: string;
  serialNumber: string;
  username: string;
  password: string;
}

export interface IEGPTaxCheckConnection {
  statusCode: number;
  resultStatus: string;
  content: IEGPTaxCheckConnectionContent;
  cacheControl: string;
  connection: string;
  pragma: string;
  contentLength: number;
  contentType: string;
  vary: string;
  xFrameOption: string;
  xxssProtection: string;
  xContentTypeOptions: string;
}

export interface IEGPTaxCheckConnectionContent {
  supportID: string;
}
